import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { CHARTS } from "./QuestionCharts";
import { BudgetBlock } from "../analysis/BudgetBlock";
import { AgentsBlock } from "../analysis/AgentsBlock";
import { LossesBlock } from "../analysis/LossesBlock";
import { ThemesBlock } from "../analysis/ThemesBlock";

export const ORDER = ["q1", "q2", "q3", "q4", "q5"];

export function Detail({ k, detail, drill, onTagged }) {
  if (!detail) return null;
  if (k === "q1") return <AgentsBlock data={detail.agents} drill={drill}/>;
  if (k === "q2") return <LossesBlock data={{ ...detail.losses, only: "face" }} labels={detail.labels} drill={drill} onTagged={onTagged}/>;
  if (k === "q3") return <><LossesBlock data={{ ...detail.losses, only: "losses" }} labels={detail.labels} drill={drill} onTagged={onTagged}/><ThemesBlock data={detail.themes} drill={drill}/></>;
  if (k === "q4") return <BudgetBlock data={detail.budget} drill={drill}/>;
  return <LossesBlock data={{ ...detail.losses, only: "face" }} labels={detail.labels} drill={drill} onTagged={onTagged}/>;
}

export function Answer({ q, k }) {
  return (
    <div className="space-y-4">
      <p className="text-base leading-relaxed text-clay-900" data-testid={`kk-r-${k}-sentence`}>{q.sentence}</p>
      <div className="border-l-4 border-terracotta pl-4 py-1" data-testid={`kk-r-${k}-rec`}>
        <div className="smallcaps mb-1">Qué hacer</div>
        <p className="text-sm leading-relaxed text-clay-800">{q.recommendation}</p>
      </div>
    </div>
  );
}

/* Layout A block: chart left, sentence + recommendation right, detail folded at the foot. */
export function Question({ k, idx, q, detail, drill, onTagged }) {
  const [open, setOpen] = useState(false);
  const Chart = CHARTS[k];
  return (
    <section className="bg-white border border-clay-200 px-6 py-6 md:px-8 md:py-7" data-testid={`kk-r-${k}`} id={`kk-r-${k}`}>
      <div className="flex items-baseline gap-3 mb-5">
        <span className="font-serif text-3xl text-terracotta leading-none tabular">{idx}</span>
        <h2 className="font-serif text-xl md:text-2xl leading-tight">{q.title}</h2>
      </div>
      <div className="grid lg:grid-cols-[3fr_2fr] gap-8">
        <div><Chart q={q} drill={drill}/></div>
        <Answer q={q} k={k}/>
      </div>
      <button type="button" onClick={() => setOpen(!open)} className="mt-6 inline-flex items-center gap-1 text-xs text-clay-600 hover:text-clay-900" data-testid={`kk-r-${k}-detail-toggle`}>
        {open ? <ChevronDown size={14}/> : <ChevronRight size={14}/>} {open ? "Ocultar detalle" : "Ver detalle"}
      </button>
      {open && <div className="mt-4 pt-4 border-t border-clay-200 space-y-4" data-testid={`kk-r-${k}-detail`}><Detail k={k} detail={detail} drill={drill} onTagged={onTagged}/></div>}
    </section>
  );
}
